import axios from 'axios'
var host = process.env.VUE_APP_API_HOST

export const paymentServices = {
  createSession,
  createSubscriptionSession,
  updateSubscription,
  createConnectedAccount,
  createPortalSession,
  getProrateInvoice,
  getConnectedAccount,
  getLocalAccount,
  // updateLocalAccount,
  createDirectPaymentSession,
  saveSellerDetail,
  getSellerDetail,
  getStripeInvoiceList,
  getFeeConfiguration,
  getFee,
  getMinimumFee
}

function createSession () {
  return new Promise(function (resolve, reject) {
    console.log('Attempting paymentServices.checkout()')
    axios.post(host + '/api/stripe/create-checkout-session')
      .then(response => {
        resolve(response.data)
      }, error => {
        console.log('Payment Error Response: ' + error.response)
        reject(error)
      })
  })
}

function createSubscriptionSession (planId) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting paymentServices.createSubscriptionSession()')
    axios.post(host + `/api/stripe/create-subscription-session/${planId}`)
      .then(response => {
        console.log('Response: ' + JSON.stringify(response))
        console.log('Data: ' + JSON.stringify(response.data))
        resolve(response.data)
      }, error => {
        console.log('Payment Error Response: ' + error.response)
        reject(error)
      })
  })
}

function getProrateInvoice (planId) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting paymentServices.getProrateInvoice()')
    axios.post(host + `/api/stripe/get-prorate-invoice/${planId}`)
      .then(response => {
        console.log('Response: ' + JSON.stringify(response))
        console.log('Data: ' + JSON.stringify(response.data))
        resolve(response.data)
      }, error => {
        console.log('Payment Error Response: ' + error.response)
        reject(error)
      })
  })
}

function updateSubscription (planId, prorateDate) {
  return new Promise(function (resolve, reject) {
    console.log(`Attempting paymentServices.updateSubscription(${planId}, ${prorateDate})`)
    var prorateOptions = {
      prorationDate: prorateDate
    }
    axios.post(host + `/api/stripe/update-subscription/${planId}`, prorateOptions)
      .then(response => {
        console.log('Response: ' + JSON.stringify(response))
        console.log('Data: ' + JSON.stringify(response.data))
        resolve(response.data)
      }, error => {
        console.log('Subscription Error Response: ' + error.response)
        reject(error)
      })
  })
}

function createPortalSession (planId) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting paymentServices.createSubscriptionSession()')
    axios.post(host + '/api/stripe/create-portal-session/')
      .then(response => {
        console.log('Response: ' + JSON.stringify(response))
        console.log('Data: ' + JSON.stringify(response.data))
        resolve(response.data)
      }, error => {
        console.log('Portal Error Response: ' + error.response)
        reject(error)
      })
  })
}

function createConnectedAccount () {
  return new Promise(function (resolve, reject) {
    console.log('Attempting paymentServices.createConnectedAccount()')
    axios.post(host + '/api/stripe/create-connected-account')
      .then(response => {
        console.log('Response: ' + JSON.stringify(response))
        console.log('Data: ' + JSON.stringify(response.data))
        resolve(response.data)
      }, error => {
        // console.log('Payment Error Response: ' + JSON.stringify(error.response))
        reject(error)
      })
  })
}

function getStripeInvoiceList () {
  return new Promise(function (resolve, reject) {
    console.log('Attempting paymentServices.getStripeInvoiceList()')
    axios.get(host + '/api/stripe/customer-invoice-list')
      .then(response => {
        console.log('Response: ' + JSON.stringify(response))
        console.log('Data: ' + JSON.stringify(response.data))
        resolve(response.data)
      }, error => {
        // console.log('Payment Error Response: ' + JSON.stringify(error.response))
        reject(error)
      })
  })
}

// don't think this is getting called anywhere
function getConnectedAccount () {
  return new Promise(function (resolve, reject) {
    console.log('Attempting paymentServices.getConnectedAccount()')
    axios.get(host + '/api/stripe/connected-account')
      .then(response => {
        console.log('Response: ' + JSON.stringify(response))
        console.log('Data: ' + JSON.stringify(response.data))
        resolve(response.data)
      }, error => {
        // console.log('Payment Error Response: ' + JSON.stringify(error.response))
        reject(error)
      })
  })
}

function getLocalAccount () {
  return new Promise(function (resolve, reject) {
    console.log('Attempting paymentServices.getLocalAccount()')
    axios.get(host + '/api/stripe/local-account')
      .then(response => {
        console.log('Response: ' + JSON.stringify(response))
        console.log('Data: ' + JSON.stringify(response.data))
        resolve(response.data)
      }, error => {
        // console.log('Payment Error Response: ' + JSON.stringify(error.response))
        reject(error.response)
      })
  })
}

function createDirectPaymentSession (templateId) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting paymentServices.createDirectPaymentSession(' + templateId + ')')
    axios.post(host + '/api/stripe/create-payment/' + templateId)
      .then(response => {
        console.log('Response: ' + JSON.stringify(response))
        console.log('Data: ' + JSON.stringify(response.data))
        resolve(response.data)
      }, error => {
        console.log('Payment Error Response: ' + JSON.stringify(error))
        reject(error)
      })
  })
}

function saveSellerDetail (user) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting paymentServices.saveSellerDetail()')
    axios.post(host + '/api/stripe/seller-detail', user)
      .then(response => {
        console.log('Response: ' + JSON.stringify(response))
        console.log('Data: ' + JSON.stringify(response.data))
        resolve(response.data)
      }, error => {
        console.log('Error Response: ' + JSON.stringify(error))
        reject(error)
      })
  })
}

function getSellerDetail () {
  return new Promise(function (resolve, reject) {
    console.log('Attempting paymentServices.getSellerDetail()')
    axios.get(host + '/api/stripe/seller-detail')
      .then(response => {
        console.log('Response: ' + JSON.stringify(response))
        console.log('Data: ' + JSON.stringify(response.data))
        resolve(response.data)
      }, error => {
        console.log('Error Response: ' + JSON.stringify(error))
        reject(error)
      })
  })
}

function getFeeConfiguration (configuration) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting paymentServices.getFeeConfiguration()')
    axios.get(host + `/api/stripe/fees/${configuration}`)
      .then(response => {
        // console.log('Response: ' + JSON.stringify(response))
        // console.log('Data: ' + JSON.stringify(response.data))
        resolve(response.data)
      }, error => {
        // console.log('Payment Error Response: ' + JSON.stringify(error.response))
        reject(error)
      })
  })
}

function getFee (configuration, price) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting paymentServices.getFee()')
    axios.get(host + `/api/stripe/fees/${configuration}/${price}`)
      .then(response => {
        console.log('Response: ' + JSON.stringify(response))
        console.log('Data: ' + JSON.stringify(response.data))
        resolve(response.data)
      }, error => {
        // console.log('Payment Error Response: ' + JSON.stringify(error.response))
        reject(error)
      })
  })
}

function getMinimumFee (configuration) {
  return new Promise(function (resolve, reject) {
    console.log('Attempting paymentServices.getMinimumFee()')
    axios.get(host + `/api/stripe/fees/${configuration}/minimum`)
      .then(response => {
        console.log('Response: ' + JSON.stringify(response))
        console.log('Data: ' + JSON.stringify(response.data))
        resolve(response.data)
      }, error => {
        // console.log('Payment Error Response: ' + JSON.stringify(error.response))
        reject(error)
      })
  })
}
